import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { waLink, DEFAULT_WA_MESSAGE } from '../data/site';

export const FloatingWhatsApp = () => (
  <motion.a
    data-testid="floating-whatsapp-button"
    href={waLink(DEFAULT_WA_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, delay: 2 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="pulse-ring fixed bottom-6 right-6 z-[60] w-16 h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_40px_rgba(37,211,102,0.45)]"
    aria-label="Falar no WhatsApp"
  >
    <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-green-300 border-2 border-white" />
    <MessageCircle size={27} className="text-white" fill="currentColor" />
  </motion.a>
);
